<template>
  <div class="pro-Rec" v-wechat-title="this.title">
    <div style="width: 103%;box-sizing: border-box;overflow-y: scroll;overflow-x: hidden;-webkit-overflow-scrolling: auto;font-size: .24rem;"  ref="wrapper" :style="{ height: (wrapperHeight) + 'px' }">
    <mt-loadmore :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" bottomPullText="" bottomDropText="正在加载..." ref="loadmore" :auto-fill="false">
    <div class="header_download" v-if="havebottom2 == '0'">
      <img src="../../assets/logo@2x.png" alt="logo" class="logo">
      <img src="../../assets/btn_download2.png" alt="下载" class="download" @click="toDownloadpage">
    </div>
    <!-- 展示播放按钮 -->
    <div style="position:relative;height: 4.21875rem;overflow: hidden;">
      <div v-show="broadcasts == '1'" class="cengs" style="width:100%;height:4.21875rem;position:absolute;top:0;left:0;z-index:20;background-size: 100% 100%;">
          <img src="../../assets/bofang1.png" @click="broadcast()" alt="" style="float:left;z-index: 20;margin:1.77rem 0 0 3.41rem; width:0.68rem;">
      </div>
      <img v-if="live.is_live == '1'" src="../../assets/label_live@2x.png" style="position:absolute;top:0.2rem;left:0.2rem;width:1.44rem;height:0.4rem;z-index:100;" alt="">
      <!-- <img v-if="live.is_live == '0'" src="../../assets/isPlay.png" style="position:absolute;top:0.2rem;left:0.2rem;width:1.12rem;height:0.4rem;z-index:100;" alt=""> -->
      <p v-if="live.is_live == '0'"  class="liveTitle" style="position:absolute;top:0.2rem;left:0.2rem;z-index:100;">
        <img src="../../assets/isPlay.png" style="width:1.12rem;height:0.4rem;vertical-align: middle;" alt="">
        {{live.title}}
        <!-- <font class="liveTitle">{{live.title}}</font> -->
      </p>
      <img @click="volumePlay()" v-if="isMute" src="../../assets/noMute.png" style="position:absolute;top:0.2rem;right:.28rem;width:.48rem;height:.44rem;z-index:100;" alt="">
      <img @click="volumePlay()" v-if="!isMute" src="../../assets/Mute.png" style="position:absolute;top:0.2rem;right:.28rem;width:.48rem;height:.44rem;z-index:100;" alt="">
      <div v-if="havebottom2 == '0'" id='id_test_video' class="id_test_vide" style="font-size:0.12rem;width:100%;height:4.21875rem;" ></div>
      <span v-if="live.is_live=='0'" class="timeend"></span>
      <span v-if="live.is_live=='0'" class="time1"></span>

    </div>
    <div  v-if="havebottom2 == '1'"  class="toRecorded" style="width:100%;height:4.22rem;">
          <div class="caption">
            <div class="split">
              <hr>
            </div>
            <div class="caption-name">直播未开始</div>
            <div class="split">
              <hr>
            </div>
          </div>
          <div class="liveTime1" style="font-size:0.21rem;padding-bottom:0.1rem;"><span style="margin-right: 0.4rem;">第一场：5月31日18:30开始</span>    <span>第二场：6月1日10:00开始</span></div>
          <p style="color: #fff;font-size: 0.21rem;text-align: center;"><span style="margin-right: 0.5rem;">第三场：6月1日15:30开始</span>    <span>决 赛：6月2日14:00开始</span></p>
          <p style="color: #fff;font-size: 0.21rem;text-align: center; padding:0.2rem 0;">现场直播</p>
          <div class="downloadMsg1">下载听见广播，遇见更多精彩</div>
    </div>
    <!-- <div class="p-msg"  v-if="havebottom == '2'">
      <img src="../../assets/toGoodList.png" alt="logo" @click="toGoodList" class="goshop">
      <p class="topic">
        {{topic}}
      </p>
      <div class="pName">
          <span>{{titles}}</span>
          <span class="dian"></span>
          <p class="num" v-show="isLive=='1'">
            <span>{{show_spectators | peopleNumber }}</span>
            <font v-if="show_spectators.length>=5">w</font>
            人正在看  
          </p>
          <p class="num" v-show="isLive=='0'">
            <span>{{show_spectators | peopleNumber }}</span>
            <font v-if="show_spectators.length>=5">w</font>
            次观看  
          </p>
      </div>

    </div> -->
    <div class="hostMsg"  v-if="havebottom == '2' && hostMsgs!==undefined && hostMsgs.length > 0 "  >
       <div class="buju">
          <!-- <div class="hostTitle">
            主持人阵容({{hostnums}})
          </div> -->
          <!-- 主持人展示 -->
          <div class="swiper-container" id="hostSwiper">
            <div class="swiper-wrapper">
              <div class="swiper-slide"  v-for="(host,index) in hostMsgs"  :key="index">
                <div class="name">
                    <div>
                      <div class="womenYes womenYes1">
                        <img :src="host.avatar" alt="" @click="goHost(host.number)">
                        <div>
                          <p class="span2" >{{host.nickname}}</p>
                          <!-- <p class="span3">{{host.job}}</p> -->
                        </div>
                        <img style="width:.44rem;height:.44rem"  @click="toDownloadpage()" src="../../assets/add.png" alt="">                       
                        <!-- <img style="width:.44rem;height:.44rem" src="../../assets/get.png" alt="">                        -->
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
      </div>


    </div>
    <!-- <div class="downloadMsg" v-if="havebottom == '2'"  @click="toDownloadpage">
      <p>
        <img src="../../assets/downNew.png" alt="" >
      </p>
    </div> -->
    <div class="radioInfo" v-if="havebottom == '1' && havebottom1 == '2'">
        <img  :src="radio_pic" alt="">
        <span>{{radio_name}}</span>
    </div>
    <div class="radioInfo" v-if="havebottom == '1' && havebottom1 == '1'">
        <img src="../../assets/liveImg.png" alt="" style="border-radius: 5%;">
        <span>听见广播APP</span>
        <span @click="toDownloadpage()" style="margin-left: 2.6rem;width: 1.42rem;height: 0.6rem;line-height: 0.6rem;border: 1px solid rgba(111, 111, 111, 0.1);margin-top: 0.3rem;">下载</span>
    </div>
     <div class="table-bar">
        <div class="table-bar-item" @click="checkTab(item.order)" :class="currentTab === item.order? 'table-bar-item-active': 'table-bar-item-default'" v-for="(item, index) in tableBar"
          :key="index"
        >
          {{ item.name }} <b></b>
        </div>
      </div>
      <div class="table_bar_item" v-show="currentTab == '1'">
         <program v-if="programList.length > 0" :commenProgram="programList" :playId="playId"></program>
         <div v-else class="noList">暂无节目</div>
      </div>
      <div class="table_bar_item" v-show="currentTab == '2'">
        <shopping v-if="shoppingList.length > 0" :commenPrograms='shoppingList'></shopping>
        <div v-else class="noList">暂无商品</div>
      </div>

  </mt-loadmore>
    </div>
    <!-- <myfooter ></myfooter> -->
    <div v-if="havebottom == '1' && havebottom1 != '1'" class="programinfo">
        <p class="programTitle">节目介绍</p>
        <p class="programMassage">{{info}}</p>
    </div>
    <div v-if="havebottom == '1' && havebottom1 == '1'" class="programinfo">
        <p class="programTitle">节目介绍</p>
        <p class="programMassage">真正为孩子创设一个想说、敢说、喜欢说，有机会说的环境，营造勇敢表达语言的氛围，为幼儿提供一个展现自我的舞台，提高幼儿的综合素质。</p>
    </div>
    <!-- <div class="showlogo" v-if="havebottom == '2'">
      <img src="../../assets/logo@2x.png" alt="logo" class="logos">
    </div> -->
    
    <div v-if="havebottom == '2'" style="height:1.14rem;"></div>
    <!-- <div class="download_bottom" v-if="havebottom == '2'" @click="toDownloadpage">
        下载APP,观看更多精彩直播
        <img src="../../assets/next_btn.png" alt="">
    </div> -->
    <img @click="shopUrl()" v-show="currentTab == '2'" class="shopping_img" src="../../assets/shopping.png" alt="">
    <myfooter :isFrom='footerData'></myfooter>
  </div>
  
</template>

<script>

 
// import myfooter from '../commen/myfooter'
import shopping from '../commen/shopping'
import program from '../commen/program'
import myfooter from "../commen/myfooter";
let connection = navigator.connection||navigator.mozConnection||navigator.webkitConnection||{tyep:'unknown'};
let type_text = ['unknown','ethernet','wifi','2g','3g','4g','none'];
import share from '../../../static/js/share.js';
import cbct from '../../../static/js/base.js'
import toast from '../commen/toast.vue'
import qs from 'qs'
import Swiper from 'swiper'

export default {
    name: 'programRecorded',
    props: {
    
    },
    
    data(){
      return {
        programRecordedMsg:[],
        hls_url:[],
        recommendRecorded:[],
        autoplay:false,
        number:'',
        type:'',
        isLive:'',
        live:'',
        isRecorded:'的回放',
        title:"",
        appName:'-听见广播',
        millions:'',
        peopleNumbers:'',
        havebottom:'',
        havebottom1:'',
        havebottom2:'0',
        info:'',
        radio_name:'',
        radio_pic:'',
        // 改动参数
        topic:'',
        titles:'',
        show_spectators:'0',
        hostImg:'',
        hostMSg:[],
        channelName:'',
        channelId:'',
        // 释放视频播放器
        player1:null, 
        period:'',
        hostMsgs:[],
        play_id:'',
        period1:'',
        //主持人数量
        hostnums:'',
        broadcasts:'1',
        currentTab: "1",
        tableBar: [
          { name: "节目回看", order: "1" },
          { name: "本地好物", order: "2" }
        ],
        programList:[],
        shoppingList:[],
        allLoaded:true,//是否加载完毕
        wrapperHeight:0,
        page:1,
        shop_url:'',
        numbers:'',
        audioBg: require('../../assets/audioBg.png'),
        playId:'',
        isMute:true,
        footerData:{name:'lifeLive','isLive':'','number':''}
      }
    },
    filters:{
      peopleNumber:function(n1){
          if (n1!="") {
              let strNum="";
          if (n1.length>=5) {
            strNum=(parseFloat(n1/10000).toFixed(1))
          }else{
            strNum=n1
          }
          return strNum     
          }
      }
    },
  
    methods:{
      volumePlay(){
        let self = this,number= 1;
        self.isMute = !self.isMute;
        self.isMute ? number = 0.6 : number = 0;
        self.player1.volume(number)
      },
        toDownloadpage() {
          //点击下载
         this.$router.push({path:"downloadApp?isFrom=programRecorded&is_live=" +this.isLive +"&number=" +this.number,});
        },
        checkTab(order) {
          this.currentTab = order;
          order == '1' ? (this.getVideoList()) : (this.getLiveProduct())
        },
        loadBottom:function(){//上拉加载
          if (!this.allLoaded) {
              this.page+=1;
              let self =this;
              self.getVideoList();
              this.$refs.loadmore.onBottomLoaded();
          }else{
              this.allLoaded=true;
          }
        },
        //往期视频
        getVideoList(){
          let _this = this,numbers = '';
          _this.$route.query.isLive == '1' ? numbers = _this.number : numbers = _this.numbers
          _this.$api.post(cbct.baseurl+"share/live-programme-play",qs.stringify({
            // number:'5144667',
            number:numbers,
            // type:1,
            // page:_this.page,
            // pageSize:10
          })).then(function(res){
            console.log(res)
            res.d.map((item)=>{
              item.play_live_time = _this.handleTime(item.play_live_time)
            })
            _this.programList = res.d
            // _this.programList = _this.programList.concat(...res.d)
            // if(res.d.length == '0' && this.page != '1'){
            //     _this.allLoaded=false;
            // }
          })
        },
        //本地好物
        getLiveProduct(){
          let _this = this
          _this.$api.post(cbct.baseurl+"share/live-product",qs.stringify({
             number:_this.number,
            channel_id:_this.channelId
          })).then(function(res){
            console.log(res)
            _this.shoppingList = res.d.list
          })
        },

        //视频播放
        broadcast:function(){
            var self = this;
            this.broadcasts = '0';
            this.stops = '0';
            $('video')[0].play();
            $('.vcp-playtoggle').css('display','block');   
        },
        shopUrl(){
          window.location.replace(this.shop_url)
        },
        get_status(){//判断网络状况
          if(typeof(connection.type) == "number"){
            connection.type_text = type_text[connection.type];
          }else{
            connection.type_text = connection.type;
          }
          if(typeof(connection.bandwidth) == "number"){
            if(connection.bandwidth > 10){
              connection.type = 'wifi';
            }else if(connection.bandwidth > 2){
              connection.type = '3g';
            }else if(connection.bandwidth > 0){
              connection.type = '2g';
            }else if(connection.bandwidth == 0){
              connection.type = 'none';
            }else{
              connection.type = 'unknown';
            }
          }
          if (connection.type_text) {
            return connection.type_text
          }else if(connection.type){
            return connection.type
          }

        
        },
        isPlay(){
          let self=this;
              self.$api.post(cbct.baseurl+"share/play",qs.stringify({
                'play_id':this.number,
                'type':this.type,
              })).then(function(res){
              if(res.c==cbct.code.successCode) {
                if(res.d.info.is_del=='1'){
                  // console.log(res.d.info.is_del)
                    self.$router.push({
                      path:'delPage'
                  })
                  return;
                }
                share.share(self,window.location.href,res.d.info.title+'的回放',res.d.live.topic,res.d.live.image,res.d.info.title+'的回放');
                share.QQshare(window.location.href,res.d.info.title+'的回放',res.d.live.topic,res.d.live.image);
                self.show_spectators = res.d.live.show_spectators;  
                self.hls_url=res.d.live.hls_url;
                self.shop_url = res.d.info.shop_url;
                self.numbers = res.d.info.number
                if(self.$route.query.title){
                  self.title=self.$route.query.title;
                }else{
                  self.title=res.d.live.title+self.isRecorded+self.appName;
                }
                if (res.d.live.hosts!==undefined && res.d.live.hosts.length > 0) {
                  self.hostMsgs=res.d.live.hosts;
                  self.hostMSg=res.d.live.hosts[0];
                }
                self.hostnums = res.d.live.hosts.length;
                self.info = res.d.info.introduction;
                self.radio_name = res.d.info.title;
                self.radio_pic = res.d.info.avatar;
                self.channelName=res.d.info.channel_name;
                self.channelId=res.d.info.channel_id;
                self.playId = res.d.live.play_id
                $('.cengs').css('background-image','url('+(res.d.live.image)+')');
                self.topic = res.d.live.topic;
                self.titles = res.d.info.title;
                if(res.d.recommend.length>0) {
                  self.recommendRecorded=res.d.recommend;
                }else if(res.d.recommend.length==0){
                  self.recommendRecorded=['none'];
                }
                self.$nextTick(function () {
                    self.hosterMsg();
                })
                self.live=res.d.live; //检测是否为空
                $('#id_test_video').html("");
                self.player1= new TcPlayer('id_test_video', {
                  "m3u8": self.hls_url,
                  autoplay:self.autoplay,
                  //iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                  "width" :  '100%',//视频的显示宽度，请尽量使用视频分辨率宽度
                  "height" : '100%',//视频的显示高度，请尽量使用视频分辨率高度
                  flashUrl:'//imgcache.qq.com/open/qcloud/video/player/release/QCPlayer.swf',
                  // poster:this.cbct.imgUrlImg()+this.cbct.getCookie('image'),
                  systemFullscreen:true,
                  "wording": {
                      2032: "请求视频失败，请检查网络",
                      2048: "请求m3u8文件失败，可能是网络错误或者跨域问题",
                  },
                  // 'controls':'none',
                  h5_flv:true,
                  flash:true,
                  live:false,

                  x5_player:true,
                  // x5_type:'h5',
                  // x5_fullscreen:'true',

                  x5_orientation:2,
                  listener:function(msg){
                      if(self.player1.playing() == true){
                          self.broadcasts = '';
                      }
                      var u = navigator.userAgent, app = navigator.appVersion;
                      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                      if(self.player1.playing() == false && self.IosAutoPlay == '0'){
                        if (isIOS) {
                            self.IosAutoPlay = '1';
                              wx.getNetworkType({
                                  success: function (res) {
                                      $('video')[0].play();
                                  }
                              });
                          }
                      } 
                      $('video').css('object-fit','fill');
                      if(isAndroid){
                          $('video').attr("x5-video-player-type","h5-page");
                      }
                      
                      $('.vcp-panel-bg').css({
                          'background': 'none !important',
                      })
                      $('.vcp-slider-thumb').css({
                          'background': 'rgba(204, 50, 50, 1) !important',
                      })                       
                      $('.vcp-slider-track').css({
                          'background': 'rgba(204, 50, 50, 1) !important',
                      })                    
                      $('.vcp-slider').css({
                          'background': 'rgba(255, 255, 255, 0.3)',
                      })                        
                      $('.vcp-timeline').css({
                          'height': '.04rem',
                          'margin-left': '2rem',
                          'width': '3.5rem',
                          // 'top':'0',
                          'left': '0',
                          'height': '.2rem',
                          'position': 'absolute',
                          'z-index': '1001',
                          'line-height':'1.5em',
                      })
                      $(".vcp-timelabel").css({
                          'opacity': '0 !important',
                      })
                      // var str=($(".vcp-timelabel").text())
                      // var a= str.split('/')[0];
                      // var b= str.split('/')[1];
                      var a = $(".vcp-timelabel").text().split('/')[1]; 
                      var b = $(".vcp-timelabel").text().split('/')[0];
                      $('.timeend').text(a)
                      $('.time1').text(b)
                      $('.vcp-timelabel').css('margin-top','0.02rem');
                  }
                });
              }else{
                  self.bus.$emit('toast',{show:true,title:res.m})
              }     
              self.timer = setInterval(function() {
                if($('.vcp-controls-panel').hasClass("show")){
                  $('.timeend').show();
                  $('.time1').show();
                  $(".vcp-timelabel").hide();
                }else{
                    $('.timeend').hide();
                    $('.time1').hide();
                }      
                  
              },100);
              var u = navigator.userAgent, app = navigator.appVersion;
              var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
              var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
              if (isAndroid) {
                  // console.log($('.vcp-fullscreen-toggle'))
                  $('.vcp-fullscreen-toggle').css('display','block');
                  $('.vcp-fullscreen-toggle').css('marginTop','0.15rem');
              }
              if (isIOS) {
                  // console.log($('.vcp-fullscreen-toggle'))
                  $('.vcp-fullscreen-toggle').css('display','block');
                  $('.vcp-fullscreen-toggle').css('marginTop','0.15rem');
              }  
            }).catch((res)=>{
                  // this.bus.$emit('toast',{show:true,title:'服务器错误'})

          });



        },
        goHost(number){
          this.$router.push({
            path:'compere?number='+number+'&type=2&user_id='+number+'&hoster_id='+number
          })
        },
        toGoodList(){
            window.location.href = cbct.dsUrl()+'/goods_list/'+this.channelId;
        },
        isLives(){
          let self=this;
            self.$api.post(cbct.baseurl+"share/live",qs.stringify({
              'number':this.number,
              'type':this.type,
              })).then(function(res){
                if(res.d.info.is_del == '1'){
                    self.$router.push({
                      path:'delPage'
                    })
                }
                share.share(self,window.location.href,res.d.info.channel_name+':'+res.d.live.title,res.d.live.topic,res.d.live.image,res.d.info.channel_name+':'+res.d.live.title+'\n话题:'+res.d.live.topic);
                share.QQshare(window.location.href,res.d.info.title,res.d.live.topic,res.d.live.image);
                if (res.c==cbct.code.successCode) {
                  self.live=res.d.live; //检测是否为空
                  // self.period=res.d.live.show_period;
                
                  if(res.d.live.is_live == undefined && self.havebottom1 == '1'){
                    self.havebottom2 = '1';
                  }
                  if (self.live.is_live == '0') {
                    if(self.havebottom1 == '1'){
                        self.havebottom2 = '1';
                    }else{
                      //  判断当期录播是否生成 录播生成
                      if (self.live.is_play=='0') {
                          self.play_id=res.d.live.play_id;
                          self.period1=res.d.live.period;
                          self.$router.push({
                          path:'programRecorded?isLive=0&live_id='+self.play_id+'&type=1&title='+self.titles+'&period='+self.period1
                        })
                      }else{
                        // 录播未生成
                        self.$router.push({
                          path:'programStop?isendShare=1&programme_id='+self.number+'&type='+self.type+'&period='+self.period
                        })

                      }
                    }
                  }
                  self.shop_url = res.d.info.shop_url
                  self.programRecordedMsg=res.d.live;
                  let m3u8_mp4 = '';
                  // self.show_spectators = res.d.live.show_spectators;
                  res.d.live.status == '1' ? (self.hls_url=res.d.live.hls_url,m3u8_mp4 = 'm3u8') : (self.hls_url=res.d.live.channel_audio_url,m3u8_mp4 = 'mp4')
                  if (res.d.live.hosts!==undefined && res.d.live.hosts.length > 0) {
                    self.hostMsgs=res.d.live.hosts;
                    self.hostMSg=res.d.live.hosts[0];
                  }
                  self.hostnums = res.d.live.hosts && res.d.live.hosts.length;
                  self.info = res.d.info.introduction;
                  self.radio_name = res.d.info.title;
                  self.radio_pic = res.d.info.avatar;
                  self.channelName=res.d.info.channel_name;
                  self.channelId=res.d.info.channel_id;
                  if(self.$route.query.title){
                    self.title=self.$route.query.title+self.appName;
                  }else{
                    self.title=res.d.live.title+self.appName;
                  }
                  self.topic = res.d.live.topic;
                  self.titles = res.d.info.title;
                  self.show_spectators = res.d.live.show_spectators;
                if (res.d.recommend.length!=0) {
                  self.recommendRecorded=res.d.recommend;
                }else if(res.d.recommend.length==0){
                  self.recommendRecorded=['none'];
                }
                self.$nextTick(function () {
                    self.hosterMsg();
                })
                $('#id_test_video').html("");
                $('.cengs').css('background-image','url('+(res.d.live.image)+')');
                self.player1 = new TcPlayer('id_test_video', {
                  'm3u8': self.hls_url,
                  autoplay:self.autoplay,

                  //iOS下safari浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
                  "width" :  '100%',//视频的显示宽度，请尽量使用视频分辨率宽度
                  "height" : '100%',//视频的显示高度，请尽量使用视频分辨率高度
                  // flashUrl:'//imgcache.qq.com/open/qcloud/video/player/release/QCPlayer.swf',
                  // poster:this.cbct.imgUrlImg()+this.cbct.getCookie('image'),
                  systemFullscreen:true,
                  "wording": {
                      2032: "请求视频失败，请检查网络",
                      2048: "请求m3u8文件失败，可能是网络错误或者跨域问题"
                  },
                  // 'controls':'none',
                  h5_flv:true,
                  flash:true,
                  live:true,

                  x5_player:true,
                  // x5_type:'h5',
                  // x5_fullscreen:'true',

                  x5_orientation:2,
                  listener:function(msg){
                      var u = navigator.userAgent, app = navigator.appVersion;
                      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                      var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                      if(self.player1.playing() == false && self.IosAutoPlay == '0'){
                        if (isIOS) {
                            self.IosAutoPlay = '1';
                              wx.getNetworkType({
                                  success: function (res) {
                                      $('video')[0].play();
                                  }
                              });
                          }
                      } 
                    if(self.live.is_live == '1' && res.d.live.status == '2'){
                      $('div.vcp-player.touchable').css('background-image','url('+(self.audioBg)+')');
                    }
                      if(self.player1.playing() == true){
                          self.broadcasts = '';
                      } 
                      $('video').css('object-fit','fill');
                      if(isAndroid){
                          // =""
                          $('video').attr("x5-video-player-type","h5-page");
                      }
                      
                      $('.vcp-panel-bg').css({
                          'background': 'none !important',
                      })
                      $('.vcp-slider-thumb').css({
                          'background': 'rgba(204, 50, 50, 1) !important',
                      })                       
                      $('.vcp-slider-track').css({
                          'background': 'rgba(204, 50, 50, 1) !important',
                      })                    
                      $('.vcp-slider').css({
                          'background': 'rgba(255, 255, 255, 0.3)',
                      })                        
                      $('.vcp-timeline').css({
                          'height': '.4rem',
                          'margin-left': '49%',
                          'width': '35%',
                          // 'top': '-10px',
                          'left': '0',
                          'height': '2rem',
                          'position': 'absolute',
                          'z-index': '1001',
                          'line-height':'1.5em',
                      })
                  }
              });
              if (self.get_status()=='wifi') {//wifi下面自动播放
                window.tcplayer.play();
              }
              }else{
                  self.bus.$emit('toast',{show:true,title:res.m})
              }
              var u = navigator.userAgent, app = navigator.appVersion;
              var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
              var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
              if (isAndroid) {
                  // console.log($('.vcp-fullscreen-toggle'))
                  $('.vcp-fullscreen-toggle').css('display','block');
                  $('.vcp-fullscreen-toggle').css('marginTop','0.13rem');
              }
              if (isIOS) {
                  // console.log($('.vcp-fullscreen-toggle'))
                  $('.vcp-fullscreen-toggle').css('display','block');
                  $('.vcp-fullscreen-toggle').css('marginTop','0.13rem');
                  $('.timeend').css('color','red');
                  $('.time1').css('bottom','-0.1rem');
              }
                
            }).catch((res)=>{
            //  console.log('节目直播res',res);
            
            });;

        },
        hosterMsg:function(){
          var swiper = new Swiper('#hostSwiper', {
              slidesPerView:'auto',
              spaceBetween: 20,
              observer:true,
              observeParents:true,
              // watchSlidesProgress : true,
              // watchSlidesVisibility : true,
              // on:{
              //     tap: function(){
              //         myPage.slideTo( swiper.clickedIndex)
              //     }
              // }
          })
        },
            /**
     * @description 将秒处理成时分秒的形式
     * @param {time} 当前秒数
     */
    handleTime(time) {
      let h, m, s,timeDom;
      h = Math.floor(time  / 60 / 60);
      m = Math.floor(time  / 60 % 60);
      s = Math.floor(time  % 60);
      h = h < 10 ? ("0" + h) : h;
      m = m < 10 ? ("0" + m) : m;
      s = s < 10 ? ("0" + s) : s;
      timeDom = h + ":" + m + ":" + s
      return timeDom
      // const h = Math.floor( time/3600 ) < 10 ?  `0${Math.floor( time/3600 )  }`: Math.floor( time/3600 ) < 10 
      // const m = Math.floor( time/60 % 60 ) < 10 ? `0${Math.floor( time/60 % 60 )}`: Math.floor( time/60 % 60 )
      // const s = Math.floor( time % 60 ) < 10 ? `0${Math.floor( time % 60 )}`: Math.floor( time % 60 )
      // return `${h}:${m}:${s}`
    },

    
    },
    created(){
        if(this.$route.query.havebottom){
            this.havebottom=this.$route.query.havebottom;
        }else{
            this.havebottom = '2';
        };
        if(this.$route.query.havebottom1){
            this.havebottom1=this.$route.query.havebottom1;
        }else{
            this.havebottom1 = '2';
        }
        let self=this;     
        if(self.$route.query.number){
          self.number=self.$route.query.number;
        }
        if(self.$route.query.live_id){
          self.number=self.$route.query.live_id;
        }
        self.type=self.$route.query.type;
        self.isLive=self.$route.query.isLive;
        self.period=self.$route.query.period;
        if (self.isLive=='0') {
          this.isPlay();
        }else if(self.isLive=='1'){
          this.isLives();
        }
        setTimeout(()=>{
          self.getVideoList()
        },500)
        this.footerData = {name:'lifeLive','isLive':this.isLive,'number':this.number}
    },
    mounted:function(){
      var self = this;
      window.onscroll=function(){
        if($(document).scrollTop() <= 8){
          $(".header_download").stop(true,true).slideDown();
          $('.download_bottom').stop(true,true).slideUp();
          // console.log('11111111111111111')
        }else if($(document).scrollTop() > 8){
          // .stop(true,true)
          $(".header_download").slideUp();
          $('.download_bottom').slideDown();
          // console.log('22222222222222222222')
        }
        // console.log('33333333333333333')
        // console.log($(document).scrollTop());
      }
console.log(this.$refs.wrapper)
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top;
    },
    watch:{
      //  解决修改url复用同一个组件不重新加载问题,因为路由相同，vue会认为是同一个页面从而复用已加载的页面，不重新加载
      '$route'(to,from){
        if (to.name==='programRecorded') {
          //  console.log(to.query);
          this.number=to.query.live_id;
          this.type=to.query.type;
          this.isLive=to.query.isLive; 
          if (to.query.isLive=='0') {
            this.isPlay();
          }else if (to.query.isLive=='1') {
              this.isLives();
          }
        }
      }
    },   
    components: {
        shopping,
        program,
        myfooter
    }
    
}
</script>
<style>
    .vcp-fullscreen-toggle{
        width: 2em;
        height: 2em;
        right: .4rem;
    }
    
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='scss'>
  *{
    margin: 0;
    padding: 0;
  }
  .timeend{ 
      position: absolute;
      bottom: .3rem;
      right: .95rem;
      display: inline-block;
      // height: .72rem;
      // line-height: .72rem;
      font-size: .24rem;
      color: #fff;
      z-index: 10;
      width: 1rem;
      text-align: center;
  }
   .time1{ 
      position: absolute;
      bottom: .3rem;
      left: .65rem;
      display: inline-block;
      // height: .92rem;
      // line-height: .92rem;
      font-size: .24rem;
      color: #fff;
      z-index: 10;
      width: 1rem;
      text-align: center;
  }
  .swiper-container{
    width: 100%;
    box-sizing: border-box;
    background: white;
    padding-bottom: 0.3rem;
    padding-top: .36rem;
    .swiper-slide {
      padding: 6px 0 6px .2rem;
      text-align: center;
      font-size: 0.24rem;
      background: #fff;
      display: -webkit-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      -webkit-justify-content: center;
      justify-content: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      -webkit-align-items: center;
      align-items: center;
      width: auto!important;
      margin-right: 15px!important; 
      border: solid .036rem rgba(232, 232, 232, 1);
      border-radius: .5rem;
      .name{
        div{
          div{
            width: auto;
            height: auto;
            display: flex;
            align-items: center;
            img{
              float: left;
              width: .52rem;
              height: .52rem;
              border-radius: 50%;
              margin-right: 0.24rem;
            }
            div{
              float: left;
              height: auto;
              width: auto;
              .span2{
                color: rgba(49, 49, 49, 1);
                font-size: 0.3rem;
                line-height: 1;
                font-weight: 500;
                padding: 0.06rem 0;
                text-align: left;
                margin-right: .2rem;
              }
              .span3{
                color: rgba(49, 49, 49, 0.3);
                font-size: 0.24rem;
                line-height: 1;
                padding: 0.05rem 0;
                text-align: left;
              }
            }
          }
        }
      }
    }

  }
  .table-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0.26rem 0 0.26rem 0.26rem;
  // margin: 0.26rem 1rem;
  font-size: 0.3rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.5);
  .table-bar-item {
    margin-right: 0.46rem;
    height: 0.44rem;
    padding-bottom: 0.14rem;
  }
  .table-bar-item-active {
    position: relative;
    color: rgba(0, 0, 0, 1);
  }
  .table-bar-item-active b {
    position: absolute;
    bottom: 0.04rem;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -50%);
    width: 0.46rem;
    height: 0.08rem;
    background: red;
    border-radius: 0.04rem;
  }
}
  .header_download{
    width: 100%;
    height: 1rem;
    display: flex;
    justify-content: space-between;
  }
  .header_download .logo{
    width: 2.88rem;
    height: 0.78rem;
    margin: 0.12rem 0 0.1rem 0.22rem;
  }
  .header_download  .download{
    width: 1.42rem;
    height: 0.6rem;
    margin: 0.2rem 0.36rem 0.2rem 0;
  }
  .download_bottom{
    display: none;
    position: fixed;
    bottom: 0;
    z-index: 100;
    width: 100%;
    padding: 0.43rem 0;
    background: rgba(235, 76, 76, 1);
    text-align: center;
    font-size: 0.3rem;
    color: rgba(255, 255, 255, 1);
  }
  .download_bottom img{
    display: inline-block;
    vertical-align: middle;
    width: 0.22rem;
    margin-bottom: 0.04rem;
    height: 0.22rem;
    margin-left: 0.12rem;
  }
  .pro-Rec{
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    /* border: solid 1px red; */
  } 
  .downloadMsg{
    box-sizing: border-box;
    border-bottom: solid 2px rgba(111, 111, 111, 0.1);
  }
  .downloadMsg p{
    height: 0.76rem;
    width: 4.4rem;
    margin:0.35rem auto 0.34rem;
  }
  .downloadMsg p img{
    width: 100%;
    height: 100%;
  }
  .p-msg{
    box-sizing: border-box;
    width: 100%;
    height: 1.6rem;
    position: relative;
  }
  .goshop{
    position: absolute;
    right: .28rem;
    top: .3rem;
    width: 1.76rem;
    height: .56rem;
    z-index: 999;
  }
  .p-msg .topic{
    font-size: 0.3rem;
    color: rgba(0, 0, 0, 1);
    font-weight: 500;
    padding: 0.41rem 0 0.05rem 0.32rem;
    line-height: 1;
    text-align: left;
  }
  .p-msg .pName>span{
    color: #000;
    font-size: 0.26rem;
    padding: 0.12rem 0 0 0.36rem;
    float: left;
    opacity: 0.3;
  }
  .p-msg .pName .dian{
    margin: 0.3rem 0.16rem;
    padding: 0;
    width: 0.04rem;
    height: 0.04rem;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.3);
  }
  .p-msg .pName .num{
    padding: 0.12rem 0 0 0;
    color: #000;
    opacity: 0.3;
  }
  .topicandNum{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .num{
    font-size: 0.24rem;
    color: rgba(91,91,91,1);
    font-weight: 500;
  }
  .pName{
    text-align: left;
    height: 0.37rem;
    line-height: 0.37rem;
    font-size: 0.26rem;
    color: rgba(102,102,102,1);
  }

  .rec-Msg{
    padding: 0.26rem 0.23rem 0.24rem; 
    /* border: solid 1px; */
  }
  .buju{
    height: auto;
    box-sizing: border-box;

    align-items: center;
    background:rgba(255,255,255,1);
    font-weight:400;
    padding: 0 0.32rem;
    justify-content: space-between;
    border-top: solid 0.02rem rgba(111, 111, 111, 0.1);
    border-bottom: solid 0.02rem rgba(111, 111, 111, 0.1);
  }
  .buju .hostTitle{
    padding: 0;
    padding-top: 0.01rem;
    font-size:0.26rem;
    font-weight: 500;
    line-height: 1;
    color: rgba(0, 0, 0, 1);
    margin:0.25rem 0.32rem 0.47rem 0;
    text-align: left;
    overflow: hidden;
  }
  .mainMsg{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .rec-Img{
    width: 0.64rem;
    height: 0.64rem;
    /* border: solid 1px; */
    
  }
  .rec-Img>img{
    width: 100%;
    height: 100%;
    display: block;
    border-radius: 100%;
  }
  .rec-Name{
    margin-left: .26rem;
    font-size: .3rem;
    color: rgba(49,49,49,1);
    font-weight: 500;
  }
  .followHost{
    font-size:0.24rem;
    color:rgba(91,91,91,1);
    font-weight: 500; 
  }
  .radioInfo{
    width: 100%;
    height: 1.3rem;
    display: flex;
    justify-content: start;
    overflow: hidden;
    margin-top: 0.1rem;
    border-bottom: 1px solid rgba(111, 111, 111, 0.1);
  }
  .radioInfo img{
    width: 0.8rem;
    height: 0.8rem;
    border-radius: 50%;
    margin-top: 0.25rem;
    margin-left: 0.42rem;
  }
  .radioInfo span{
    font-size: 0.3rem;
    color: #333;
    line-height: 1.3rem;
    margin-left: 0.1rem;
    max-width: 5.8rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .programinfo{
    margin-top: 5px;
    font-size: 0.26rem;
    color: #666666;
  }
  .programTitle{
    text-align: left;
    padding-left: 0.32rem;
    line-height: 0.8rem;
    font-size: 0.28rem;
    color: #333;
    font-weight: bold;
  }
  .programMassage{
    padding: 0 0.32rem;
    text-align: left;
    line-height: 0.35rem;
  }
  .toRecorded{
    width: 100%;
    height: 4.22rem;
    box-sizing: border-box;
    text-align: center;
    background: rgba(0,0,0,.9);

  }
  .channelName{
    box-sizing: border-box;
    padding: 0.47rem 0;
    border-bottom: solid 1px rgba(111, 111, 111, 0.1);
    font-size: 0.32rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: rgba(49, 49, 49, 1); 
    }
  .channelName img{
    width: 0.22rem;
    height: 0.22rem;
    margin-left: 0.16rem;
  }
  .channelInfo{
    font-size: 0.24rem;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
    padding: 0.25rem 0 0.23rem;
  }
  .boldLine{
    height: 0.2rem;
    background: rgba(248, 248, 248, 1)
  }
  .caption{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0.24rem;
  }
  .split{
    flex-grow: 1;
  }
  .split hr{
      height:0.01rem;
      background:rgba(0,0,0,1);
      opacity:0.55;
      border: none;
      border-top: 2px solid rgba(111, 111, 111, 0.1);
      margin-top: 0.95rem;

  }
  .caption-name{
    min-width:2.1rem;
    padding: 0 0.32rem;
    height:0.59rem;
    font-size:0.42rem;
    font-weight:400;
    color:white;
    line-height:0.59rem;
    margin-top: 0.95rem;

  }
  .showTime{
    font-size: 0.3rem;
    color: rgba(170,170,170,1);
    margin: 0.32rem auto 0.34rem;
  }
  .lookRecorded img{
    width: 2.4rem;
  }
  .programStop{
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
  } 
  .compere-stop{
    width: 100%;
  }
  .compereMes{
    width: 100%; 
  }
  .liveStop{
    width: 100%;
    height: 0.39rem;
    line-height: 0.39rem;
    box-sizing: border-box;
    display: inline-block;
    font-size:0.42rem;
    font-weight:500;
    color:rgba(51,51,51,1);
    margin-top: 0.56rem;
    text-align: center;
  }
  .comImg{
    width: 1.78rem;
    height: 1.78rem;
    margin:0.4rem auto 0.23rem;
    text-align: center; 
  }
  .marginT{
    margin: 0.44rem auto 0.24rem;
  }
  .comImg img{
    width: 100%;
    height: 100%;
    border-radius: 0.2rem;
  }
  .comName{
    height: 0.4rem;
    box-sizing: border-box;
    margin: 0rem auto 0.33rem;
    text-align: center;
    font-size:0.42rem;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:0.4rem;
  }
  .comCaption{
    width:2.39rem;
    height:0.23rem;
    font-size:0.24rem;
    font-weight:bold;
    color:rgba(102,102,102,1);
    line-height:0.45rem;
    margin: 0.24rem auto 0.3rem;
    background: darkgreen;
  }
  .hostsMsg{
    height: 0.68rem;
    font-size:0.24rem;
    font-weight:400;
    color:rgba(102,102,102,1);
  }
  .liveName{
    height: 0.22rem; 
    box-sizing: border-box; 
    line-height:0.22rem;
    text-align: center;
  }
  .liveTime{
    height: 0.22rem;
    line-height: 0.22rem;
    text-align: center;
    margin: 0.24rem auto 0;
  }
  .downloadApp{
    /* height: 1.08rem; */
    width: 4.4rem;
    box-sizing: border-box;
    margin:0.35rem auto 0.34rem;
  }
  .downloadApp img{
    width: 100%;
    height: 100%;
  }
  .programContainer{
    box-sizing: border-box;
  }
  .Con{
    box-sizing: border-box;
    padding: 0.24rem 0.24rem 0rem 0.24rem;
  }
  .comMessage{
    width: 100%;
    /* display: flex; */
    /* border: solid 1px; */
  }
  .comImg{
    width: 1.88rem;
    height: 1.88rem;
    vertical-align: middle;
    /* border: solid 1px; */
  }
  .comImg>img{
    width: 100%;
    height: 100%;
    border-radius:0.1rem;
  }
  .programMsg{
    text-align: left;
    font-size:0.28rem;
    font-weight:500;
    color:rgba(102,102,102,1);
  }
  .programMsg p{
    margin: 0.16rem 0;
  }
  .liveTime1{
    color: #fff;
    font-size: 0.30rem;
    text-align: center;
    padding: 0.4rem;
  }
  .downloadMsg1{
    color: #fff;
    font-size: 0.24rem;
    text-align: center;
  }
  .showlogo{
    width: 100%;
    height: auto;
  }
  .showlogo .logos{
    width: 2.88rem;
    margin: 0.3rem 2.31rem;
    height: 0.78rem;
  }
  .shopping_img{
  width: 1.64rem;
  height: 1.64rem;
  position: absolute;
  bottom: 1.64rem;
  right: .24rem;
}
.noList{
    height: 6.16rem;
    line-height: 6rem;
    color: rgba(153, 153, 153, 1);
    font-size: .34rem;
}
.liveTitle{
    height: .4rem;
    width: 5.5rem;
    text-align: left;
    color: white;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 0.28rem;
    font-weight: 500;
    white-space: wrap;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
}
</style>
